export default __webpack_public_path__ + "static/chat-e249e82e970aa50dda5761c28d7fcee9.png";